import React from 'react'
import { useBoolean } from 'react-hanger'
import { observer } from 'mobx-react-lite'
import { DragIndicator } from '@styled-icons/material/DragIndicator'
import { Pencil } from '@styled-icons/boxicons-solid/Pencil'
import { Trash2 } from '@styled-icons/bootstrap/Trash2'
import { ChevronRight } from '@styled-icons/boxicons-regular/ChevronRight'
import { Linkedin } from '@styled-icons/bootstrap/Linkedin'
import { SortableElement } from 'react-sortable-hoc'
import { Modal, Card } from 'antd'
import classnames from 'classnames'

import { DragHandle } from '../../dragHandle'
import { UserModuleType, LinkedInType } from '../../../../../models'
import { useContext } from '../../../context'
import { EditModal } from './components/edit'

interface Props {
	module: UserModuleType
}

export const LinkedInModule = SortableElement(observer(({ module }: Props) => {

	const context = useContext()

	const showConfig = useBoolean(false)

	const data = React.useMemo(() => module.data as LinkedInType, [module.data])

	const openLinkedIn = React.useCallback(() => {
		if (context.editingScreen) return
		window.open(`https://linkedin.com/in/${data.username}`)
	}, [context.editingScreen, data])

	const removeModule = React.useCallback((confirmed?: boolean) => () => {
		if (confirmed) {
			context.modules = context.modules.filter(m => m._id !== module._id)
		} else {
			Modal.confirm({
				title: false,
				icon: false,
				content: `Deseja remover o módulo "LinkedIn" ?`,
				onOk: removeModule(true)
			})
		}
	}, [context, module])

	React.useEffect(() => {
		if (module.isNew) showConfig.setTrue()
	}, [])  // eslint-disable-line

	return (
		<Card className={classnames({ 'cursor-pointer': !context.editingScreen })} onClick={openLinkedIn}>
			<div className={`h-10 flex flex-row space-x-4 m-4 items-center`}>
				{/* @ts-expect-error */}
				{context.editingScreen && (<DragHandle><DragIndicator className={`text-gray-500 w-8 -mx-4`} /></DragHandle>)}
				<Linkedin className={`text-blue-700 w-8`} />
				<div className={`flex-1`}>
					<div className={`font-bold`}>{`LinkedIn`}</div>
					<div className={`text-xs opacity-50`}>{data.alias}</div>
				</div>
				<div className={`flex flex-row space-x-5`}>
					{
						context.editingScreen
							? (
								<>
									<Pencil onClick={showConfig.setTrue} className={`w-5 mr-1 text-gray-500`} />
									<Trash2 onClick={removeModule()} className={`w-5 text-red-500`} />
								</>
							)
							: (
								<ChevronRight className={`w-8 text-gray-500`} />
							)
					}
				</div>
			</div>
			<EditModal show={showConfig.value} module={module} close={showConfig.setFalse} />
		</Card>
	)
}))